import { formatDate } from '@eluve/date-utils';
import { ResultOf } from '@eluve/graphql.tada';
import { formatHumanName } from '@eluve/utils';

import { patientOptionFragment } from './operations';

export type PatientOptionInfo = Omit<
  ResultOf<typeof patientOptionFragment>,
  '__typename'
>;

export const getName = (
  patient: Pick<PatientOptionInfo, 'firstName' | 'lastName'>,
) => formatHumanName(patient.firstName, patient.lastName);

export const getPatientDetails = (
  patient: PatientOptionInfo,
  dobLabel: string,
) => {
  const dob = patient.dateOfBirth;
  if (dob) {
    return `${dobLabel} ${formatDate.toMMMDD(dob)}`;
  }
  const patientPhoneNumber = patient.external_patients_info.find(
    (info) =>
      Boolean(info.homePhoneNumber) ||
      Boolean(info.workPhoneNumber) ||
      Boolean(info.cellPhoneNumber),
  );
  if (patientPhoneNumber) {
    return (
      patientPhoneNumber?.homePhoneNumber ??
      patientPhoneNumber?.workPhoneNumber ??
      patientPhoneNumber?.cellPhoneNumber
    );
  }
  const patientEmail = patient.external_patients_info.find((info) =>
    Boolean(info.email),
  );
  if (patientEmail) {
    return patientEmail.email;
  }
  return '';
};
